<template>
  <BLayoutExpansionTable
    v-bind="$attrs"

    :value="list"
    :readonly="readonly"
    :skeleton="skeleton"
    :validate="validate"
    :pagination="pagination"
    type-table="publication-storage"

    :title="title"
    :creatable="creatable"
    :button-text="buttonText"

    v-on="$listeners || {}"
  >
    <template v-for="(_, key) in $scopedSlots" #[key]="props">
      <slot v-bind="props" :name="key" />
    </template>
  </BLayoutExpansionTable>
</template>

<script>
import BLayoutExpansionTable from '@/components/layouts/BLayoutExpansionTable.vue'


export default {
  name: 'PublicationStorageExpansionTable',
  components: {
    BLayoutExpansionTable,
  },
  inheritAttrs: false,
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    readonly: Boolean,
    skeleton: Boolean,
    pagination: Object,
    validate: [String, Object],

    title: String,
    creatable: Boolean,
    buttonText: String,
  },
}
</script>
